<template>
  <main class="home-hero">
    <section id="home-header" class="d-flex flex-column justify-content-center align-items-center">
      <div class="hero-content">
        <img src="@/assets/img/xalor_logo.png" alt="Xalor Logo" class="hero-logo animate__animated animate__fadeInDown" />
        
        <p class="hero-subtitle animate__animated animate__fadeInUp animate__delay-1s">
          THE CRYSTALLINE ODYSSEY AWAITS. JOIN THE ADVENTURE.
        </p>

        <div class="hero-actions d-flex flex-column flex-md-row justify-content-center align-items-center animate__animated animate__fadeInUp animate__delay-2s">
          <router-link to="/download" class="btn-gold mx-2 mb-3 mb-md-0">
            <i class="fas fa-download mr-2"></i> PLAY NOW
          </router-link>
          <a href="https://discord.gg/xalor" target="_blank" class="btn-purple mx-2">
            <i class="fab fa-discord mr-2"></i> JOIN DISCORD
          </a>
        </div>
      </div>
    </section>
  </main>
</template>
<script setup>
</script>
